<div class="modal-header">
    <h4 class="modal-title"
        [innerHtml]="('ADD_USER'|translate)"></h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.close('Close click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<app-user-crud  [userId]="null" [mode]="'create'"></app-user-crud>
<div class="filter-for-list">
    <!--{{projectUsers.length}}-->

    <mat-form-field placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
        <input matInput [value]="users ? users.filter : null" (keyup)="applyFilter($event.target.value)" [placeholder]="'SEARCH' | translate">
    </mat-form-field>

    <div class="deviceTypeFilter" style="margin-left:50px" placement="right"
         [ngbTooltip]="'ROLES_TYPE_CHIPS' | translate">

        <mat-chip-list>
            <mat-chip *ngFor="let role of roles  index as i "
                      [ngClass]="{'selected' : role.name === rolesSelected}"
                      (click)="filterListByRole(role.name)">
                {{role.name | translate}}
            </mat-chip>
        </mat-chip-list>

    </div>

    <br clear="both"/>
</div>
<app-progressbar *ngIf="showSpinner===true"></app-progressbar>
<table mat-table [dataSource]="users" matSort class="table-striped" style="width:100%">

    <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ID'|translate}}</th>
        <td mat-cell *matCellDef="let user"> {{user.id}}</td>
    </ng-container>

    <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'EMAIL'|translate}}</th>
        <td mat-cell *matCellDef="let user"> <b>{{user.email}}</b>
        </td>
    </ng-container>

    <ng-container matColumnDef="firstname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'FIRSTNAME'|translate}}</th>
        <td mat-cell *matCellDef="let user"> {{user.firstname}}
        </td>
    </ng-container>


    <ng-container matColumnDef="lastname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LASTNAME'|translate}}</th>
        <td mat-cell *matCellDef="let user"> {{user.lastname}}
        </td>
    </ng-container>

    <ng-container matColumnDef="roles">
        <th mat-header-cell *matHeaderCellDef>{{'ROLES'|translate}}</th>
        <td mat-cell *matCellDef="let user">
        <span class="inner-badge"
              *ngFor="let role of getClientOrInstallerRoles(user.roles)">{{role}}</span>
        </td>
    </ng-container>


    <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>{{'ACTIONS'|translate}}</th>
        <td mat-cell *matCellDef="let user">

            <mat-icon style="color:green;cursor:pointer" (click)="addUserToProject(user.id,user.email)"
                      matTooltipPosition="right"
                      [matTooltip]="'CREATE_ICON_TOOLTIP'|translate">check_circle
            </mat-icon>
        </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>

<mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [pageSize]="5"></mat-paginator>


<div class="modal-footer">

    <button type="button" class="btn btn-light" (click)="activeModal.close('Close click')"
            [innerHTML]="'CLOSE' | translate">Close
    </button>
</div>
